import { render, staticRenderFns } from "./learn-about.vue?vue&type=template&id=74c2ab24&scoped=true&"
import script from "./learn-about.vue?vue&type=script&lang=js&"
export * from "./learn-about.vue?vue&type=script&lang=js&"
import style0 from "./learn-about.vue?vue&type=style&index=0&id=74c2ab24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c2ab24",
  null
  
)

export default component.exports